import { IJSLVNode, IJSLComponent, refresh } from "jsl-render";
import { FormFieldComponent, InputComponent, LoadingComponent } from "jsl-ui";
import { PublicController } from "../../ajax/PublicController";

export class ContactComponent implements IJSLComponent {

    private name: FormFieldComponent;
    private email: FormFieldComponent;
    private betreff: FormFieldComponent;
    private nachricht: InputComponent;
    private isSending = false;
    private isDoneMsg = null;

    public constructor() {
        this.name = new FormFieldComponent({ label: "Name", class: "common-input mt-10" });
        this.email = new FormFieldComponent({ label: "E-Mail", class: "common-input mt-10" });
        this.betreff = new FormFieldComponent({ label: "Betreff", class: "common-input mt-10" });
        this.nachricht = new InputComponent({ type: "textarea", style: "height:6rem; width:95%" });
    }

    public render(): IJSLVNode {
        if (this.isDoneMsg) {
            return <section class="banner-area">
                <div style="max-width:20rem;margin:1rem auto;">
                    <h2>{this.isDoneMsg}</h2>
                    <a href="/">zurück zur Startseite</a>
                </div>
            </section>;
        }
        return <section class="banner-area">
            <div style="max-width:20rem;margin:1rem auto;">
                {this.name}
                {this.email}
                {this.betreff}
                <p>Nachricht</p>
                <p>{this.nachricht}</p>
                {this.isSending ? new LoadingComponent() :
                    <button class="genric-btn default-border" click={() => {
                        this.send();
                    }}>Senden</button>}
            </div>
        </section>;
    }

    private async send() {
        const name = this.name.getValue();
        const email = this.email.getValue();
        const betreff = this.betreff.getValue();
        const nachricht = this.nachricht.getValue();
        if (!name) {
            alert("Bitte geben Sie Ihren Namen an");
            return;
        }
        if (!email) {
            alert("Bitte geben Sie Ihre Email Adresse an");
            return;
        }
        if (!betreff) {
            alert("Bitte geben Sie einen Betreff an");
            return;
        }
        if (!nachricht) {
            alert("Bitte geben Sie eine Nachricht an an");
            return;
        }
        this.isSending = true;
        try {
            await PublicController.SendMessage({ name, email, betreff, nachricht });
            this.isDoneMsg = "Nachricht erfolgreich verschickt :)";
        } catch (e) {
            this.isDoneMsg = "Beim senden ist ein Fehler aufgetreten";
        }
        refresh();
    }

}
